import Image from 'next/image';
import Link from 'next/link';

export default function Hero() {
  return (
    <header className="hero" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgba(15, 29, 58, 0.92) 0%, rgba(10, 20, 41, 0.92) 100%), var(--navy)',
      backgroundColor: 'var(--navy)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'var(--cream)',
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: '1.1fr 0.9fr',
      alignItems: 'center',
      padding: '8rem 3rem 4rem',
      gap: '4rem',
      overflow: 'hidden',
    }}>
      {/* Decorative corners */}
      <div style={{
        position: 'absolute', top: 100, left: 30,
        width: 140, height: 140,
        border: '3px solid var(--gold)', opacity: 0.75,
        borderRight: 'none', borderBottom: 'none',
        pointerEvents: 'none', zIndex: 1,
      }} />
      <div style={{
        position: 'absolute', bottom: 30, right: 30,
        width: 140, height: 140,
        border: '3px solid var(--gold)', opacity: 0.75,
        borderLeft: 'none', borderTop: 'none',
        pointerEvents: 'none', zIndex: 1,
      }} />

      <div className="hero-content" style={{ zIndex: 2 }}>
        <div className="hero-eyebrow" style={{
          display: 'flex', alignItems: 'center', gap: '1rem',
          color: 'var(--gold)', fontSize: '0.78rem',
          letterSpacing: '0.35em', textTransform: 'uppercase',
          marginBottom: '1.8rem', fontWeight: 400,
        }}>
          <span className="hero-line-left" style={{ height: 1, background: 'var(--gold)', flex: '0 0 40px' }} />
          50th Anniversary · 1976 — 2026
          <span className="hero-line-right" style={{ height: 1, background: 'var(--gold)', flex: 1, maxWidth: 200 }} />
        </div>

        <h1 style={{
          fontFamily: "'Fraunces', serif", fontWeight: 300,
          fontSize: 'clamp(2.8rem, 6vw, 5.2rem)',
          lineHeight: 1.02, letterSpacing: '-0.02em',
          marginBottom: '1.5rem', textAlign: 'center',
        }}>
          Celebrating
          <span className="fifty-line" style={{
            display: 'flex', alignItems: 'baseline', justifyContent: 'center',
            gap: 'clamp(1rem, 2.5vw, 2.5rem)', margin: '0.6rem 0 0.4rem',
            flexWrap: 'nowrap', lineHeight: 1.15,
          }}>
            <span className="fifty" style={{
              display: 'inline-block',
              fontFamily: "'Fraunces', serif", fontWeight: 900,
              fontStyle: 'italic',
              fontSize: 'clamp(4rem, 10vw, 8.5rem)',
              lineHeight: 1.15,
              background: 'linear-gradient(180deg, var(--gold-light) 0%, var(--gold) 60%, #a07d2f 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>Fifty</span>
            <span className="fifty" style={{
              display: 'inline-block',
              fontFamily: "'Fraunces', serif", fontWeight: 900,
              fontStyle: 'italic',
              fontSize: 'clamp(4rem, 10vw, 8.5rem)',
              lineHeight: 1.15,
              background: 'linear-gradient(180deg, var(--gold-light) 0%, var(--gold) 60%, #a07d2f 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>Years</span>
          </span>
          <span className="of-line" style={{
            display: 'block',
            fontFamily: "'Fraunces', serif", fontWeight: 300,
            fontSize: 'clamp(1.8rem, 3.5vw, 3rem)',
            lineHeight: 1.15, marginTop: '0.3rem',
          }}><em style={{ fontStyle: 'italic', fontWeight: 400, color: 'var(--gold)' }}>of</em></span>
          <span className="school-line" style={{
            display: 'block',
            fontFamily: "'Fraunces', serif", fontWeight: 300,
            fontSize: 'clamp(1.8rem, 3.5vw, 3rem)',
            lineHeight: 1.15,
          }}><em style={{ fontStyle: 'italic', fontWeight: 400, color: 'var(--gold)' }}>Queen of Angels</em></span>
          <span className="school-line" style={{
            display: 'block',
            fontFamily: "'Fraunces', serif", fontWeight: 300,
            fontSize: 'clamp(1.8rem, 3.5vw, 3rem)',
            lineHeight: 1.15,
          }}><em style={{ fontStyle: 'italic', fontWeight: 400, color: 'var(--gold)' }}>Primary School</em></span>
        </h1>

        <p className="lede" style={{
          fontFamily: "'Cormorant Garamond', serif", fontSize: '1.35rem',
          fontStyle: 'italic', fontWeight: 400,
          maxWidth: 580, margin: '0 auto 2.5rem',
          color: 'rgba(246, 241, 230, 0.85)',
          lineHeight: 1.5, textAlign: 'center',
        }}>
          Past pupils, current parents, parishioners and neighbours — wherever your path has taken you, the doors of Queen of Angels Primary School are open for you.
          <br />
          Join us for a year of remembrance, reunion and celebrations.
        </p>

        <div className="hero-cta" style={{
          display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center',
        }}>
          <Link href="#register" className="btn-primary">Register Your Interest</Link>
          <Link href="#events" className="btn-secondary">View the Year Ahead</Link>
        </div>
      </div>

      <div className="hero-crest" style={{
        position: 'relative', zIndex: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div className="crest-wrap" style={{
          position: 'relative', width: 380, height: 380,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div className="crest-ring" style={{
            position: 'absolute', inset: 0,
            border: '1px solid var(--gold)', borderRadius: '50%', opacity: 0.5,
          }} />
          <div className="crest-ring r2" style={{
            position: 'absolute', inset: 20,
            border: '1px solid var(--gold)', borderRadius: '50%', opacity: 0.3,
            borderStyle: 'dashed',
          }} />
          <span className="crest-year top" style={{
            position: 'absolute', top: 8,
            fontFamily: "'Fraunces', serif", fontWeight: 600,
            fontStyle: 'italic', color: 'var(--gold)',
            fontSize: '0.85rem', letterSpacing: '0.3em',
          }}>MCMLXXVI</span>
          <Image src="/logo.png" alt="Queen of Angels school crest" width={260} height={260} priority style={{
            width: 'auto', height: 260,
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))',
            zIndex: 2, position: 'relative',
          }} />
          <span className="crest-year bottom" style={{
            position: 'absolute', bottom: 8,
            fontFamily: "'Fraunces', serif", fontWeight: 600,
            fontStyle: 'italic', color: 'var(--gold)',
            fontSize: '0.85rem', letterSpacing: '0.3em',
          }}>MMXXVI</span>
        </div>
      </div>


    </header>
  );
}
